import { Button, Grid, Stack, useMediaQuery, TextField } from "@mui/material";
import { Image, Modal, Typography } from "antd";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";

import BidDetails from "../Bids/BidDetails";

import ScopeDetails from "../Scope/ScopeDetails";
import AnimateButton from "../../../../Layout/components/@extended/AnimateButton";
import EditScopeForm from "../Scope/EditScopeForm";

import { useUserState } from "../../../../Context/UserContext";
import LoadScreen from "../../../../Components/LoadScreen";
import { FilePdfTwoTone } from "@ant-design/icons";
import Video from "../../API/Video";
import AddImageModal from "../ClientPhases/AddImageModal";
import { ScopeDetailSection } from "../ClientPhases/ScopeDetailSection";
import NewPaymentMethod from "../../../NewPaymentMethod";

const ExpandedTilePhase1 = (props) => {
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [imageSubmitAlert, setImageSubmitAlert] = useState(false);
  const [scopeFinalTotal, setScopeFinalTotal] = useState("");

  useEffect(() => {
    if (imageSubmitAlert) {
      const timeoutId = setTimeout(() => {
        setImageSubmitAlert(false);
      }, 5000); // Adjust the timeout duration (in milliseconds) as needed

      return () => clearTimeout(timeoutId); // Clear timeout when component unmounts or alert is hidden
    }
  }, [imageSubmitAlert]);

  const { user } = useUserState();

  const [showBidDetailsModal, setShowBidDetailsModal] = useState(false);
  const [showAcceptBidModal, setShowAcceptBidModal] = useState(false);
  const [cancelBidAlert, setCancelBidAlert] = useState(false);
  const [openScopeModal, setOpenScopeModal] = useState(false);
  const [editScopeModal, setEditScopeModal] = useState(false);
  const [index, setIndex] = useState(0);
  const [chargePercentages, setChargePercentages] = useState({
    clientPercentage: 0,
    vendorPercentage: 0,
  });
  const [currentScope, setCurrentScope] = useState(props.scopeDetails[index]);
  const [confirmationText, setConfirmationText] = useState("");
  const [confirmationError, setConfirmationError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addPaymentMethodModal, setAddPaymentMethodModal] = useState(false);
  const [paymentRequiredModal, setPaymentRequiredModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(false);

  const fetchPaymentMethod = () => {
    axios
      .post("/stripe/getClientPaymentMethod", {
        userID: props.jrData.client_id,
      })
      .then((res) => {
        if (res.data.paymentMethod !== null && res.data.ok) {
          console.log(res.data.paymentMethod, "fibhwhfuebif");
          setPaymentMethod(true);
        } else {
          console.log(res.data, "fbwuhfeibfi");
          setPaymentMethod(false);
        }
      });
  };

  // useEffect(() => {
  //   fetchPaymentMethod();
  // }, []);

  const onSuccess = () => {
    setAddPaymentMethodModal(false);
    setPaymentRequiredModal(false);
    fetchPaymentMethod();
  };
  const mayBeLater = () => {
    setAddPaymentMethodModal(false);
    setPaymentRequiredModal(false);
  };

  const setBidAsViewed = useCallback(() => {
    axios.post("/notifications/bidViewed", { jobID: props.jrData.job_id });
  }, [props.jrData.job_id]);

  const fetchBidDetails = useCallback(() => {
    setBidAsViewed();
  }, [setBidAsViewed]);
  useEffect(() => {
    setCurrentScope(props.scopeDetails[index]);
  }, [
    chargePercentages.clientPercentage,
    chargePercentages.vendorPercentage,
    index,
    props.scopeDetails,
    user.vendorMode,
  ]);
  useEffect(() => {
    axios.get("/finance/getChargePercentages").then((response) => {
      setChargePercentages(
        props.jrData.is_send_to_market === 1
          ? response.data.marketPercentages
          : response.data.crmPercentages
      );
    });
  }, []);

  const handleConfirmationChange = (event) => {
    setConfirmationText(event.target.value);
    setConfirmationError(event.target.value.trim() === "");
  };

  const cancelBidConfirm = () => {
    axios
      .post("/bidding/cancelBids", {
        bidId: props.bidDetails[0].bid_id,
        requestedJobId: props.bidDetails[0].requested_job_id,
      })
      .then((res) => {
        window.location.reload();
      });
  };

  useEffect(() => {
    fetchBidDetails();
  }, [fetchBidDetails]);

  const mobileView = useMediaQuery("(max-width: 600px)");

  console.log(confirmationText, "confirmationText");

  const acceptBid = () => {
    const bid = props.bidDetails[0];
    let bidObject = {
      bidId: bid.bid_id,
      bidVendorId: bid.bid_vendor_id,
      requestedJobId: bid.requested_job_id,
      workToBeDone: bid.work_to_be_done,
      labourCharge: bid.labour_charge,
      estimatedHours: bid.estimated_hours,
      estimatedMaterials: bid.estimated_materials,
      bidAmount: bid.bid_amount,
      bidDate: bid.bid_date,
      notes: bid.notes,
      host: window.location.host,
    };
    setIsSubmitting(true);

    // First API call to accept bid
    axios
      .post("/bidding/acceptBid", {
        bidId: bidObject.bidId,
        jobId: bidObject.requestedJobId,
        activityDesc: `Accepted bid for $${bidObject.bidAmount.toFixed(2)}`,
        userName: `${user.first_name} ${user.last_name}`,
        host: window.location.host,
        reason: confirmationText,
      })
      .then((res) => {
        if (res.data.ok) {
          // Second API call to close bids
          return axios.post("/bidding/closeBids", {
            bidId: bidObject.bidId,
            requestedJobId: bidObject.requestedJobId,
            AssignedVendorId: user.id,
          });
        } else {
          throw new Error("Accept bid failed");
        }
      })
      .then((res) => {
        // Update job status to Scheduling
        return axios.post("/jobRequest/updateToScheduling", {
          jobId: bidObject.requestedJobId,

          activityDesc: "Job moved to scheduling phase",
          userName: `${user.first_name} ${user.last_name}`,
        });
      })
      .then((res) => {
        // Only update UI if all operations succeed
        props.fetchData();
        props.fetchJrData();

        setShowAcceptBidModal(false);
        setShowBidDetailsModal(false);
      })
      .catch((error) => {
        console.error("Error in bid acceptance process:", error);
        // You might want to show an error message to the user here
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  console.log("Rendering ExpandedTilePhase1");
  // console.log(props.jrData);
  console.log(props.bidDetails, "bidDetails");
  return (
    <>
      {props.jrImages !== "" && (
        <Grid container spacing={1} width={"100%"} margin={"1rem 0 0 0"}>
          <Stack spacing={1} direction={"column"} width={"100%"}>
            <Grid item sm={12} md={8}>
              <Stack spacing={1}>
                <Stack direction={"row"} spacing={1}>
                  <Typography className="title">Problem Description</Typography>
                </Stack>
                <Typography
                  style={{
                    width: "350px",
                    overflowWrap: "break-word",
                    wordWrap: "break-word",
                  }}
                >
                  {props.jrData.job_description}
                </Typography>
                <Typography className="title">
                  Images / Documents
                  {props.jrData.created_vendor_id !== null ? (
                    <Button
                      variant="contained"
                      type="primary"
                      style={{ marginLeft: 10 }}
                      onClick={() => setShowImageUploadModal(true)}
                    >
                      Add
                    </Button>
                  ) : null}
                </Typography>
                <Stack spacing={1} direction={"row"}>
                  {props.jrImages.map((media, i) => {
                    // Extract file extension from the source URL

                    const fileExtension = media.imageurl
                      .split(".")
                      .pop()
                      .toLowerCase();

                    // Check if it's an image based on the file extension
                    const isImage = ["jpg", "jpeg", "png", "gif"].includes(
                      fileExtension
                    );

                    if (isImage) {
                      return (
                        <Image
                          key={media.jobrequest_images_id}
                          width={80}
                          src={media.image}
                        />
                      );
                    } else {
                      return (
                        <Video
                          key={media.jobrequest_images_id}
                          src={media.image}
                          width={80}
                        />
                      );
                    }
                  })}
                </Stack>

                {showImageUploadModal && (
                  <AddImageModal
                    onClose={() => setShowImageUploadModal(false)}
                    showImageUploadModal={showImageUploadModal}
                    setImageSubmitAlert={setImageSubmitAlert}
                    jrData={props.jrData}
                    fetchData={props.fetchData}
                    fetchJrData={props.fetchJrData}
                  />
                )}
              </Stack>
            </Grid>
            {!props.bidDetails ? (
              <LoadScreen />
            ) : (props.bidDetails === false ||
                props.bidDetails?.length === 0) &&
              (user.empRole === "Admin" || user.empRole === "Manager") ? (
              <div className={"btnContainer"}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    props.setShowSubmitForm(true);
                    props.fetchData();
                  }}
                >
                  Submit Bid
                </Button>
              </div>
            ) : (
              props.bidDetails?.length > 0 &&
              (props.bidDetails[0].is_accepted === 0 &&
              props.bidDetails[0].is_closed === 0 ? (
                <div>
                  {props.bidDetails[0].is_cancelled === 0 ? (
                    <>
                      {props.jrData.assigned_vendor_id === null ? (
                        <h1 style={{ marginTop: "1rem" }}>
                          <em>Waiting for client to respond to your bid.</em>
                        </h1>
                      ) : (
                        <h1 style={{ marginTop: "1rem" }}>
                          <em>Accept this bid with the client's approval.</em>
                        </h1>
                      )}

                      <Stack direction={"row"} gap={"1rem"}>
                        {props.jrData.created_vendor_id != null ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => {
                              setShowAcceptBidModal(true);
                            }}
                          >
                            Accept Bid
                          </Button>
                        ) : null}
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => {
                            setShowBidDetailsModal(true);
                          }}
                        >
                          View Bid
                        </Button>
                      </Stack>
                    </>
                  ) : (
                    <h1 style={{ marginTop: "1rem" }}>
                      <em>You cancelled your bid.</em>
                    </h1>
                  )}
                </div>
              ) : !props.bidDetails?.is_accepted ? (
                // !mobileView && (
                <>
                  {props.scopeDetails !== "" && props.scopeDetails.length > 0 && (
                    <>
                      <Grid container spacing={1}>
                        {/* {(user.empRole === "Admin" ||
                              user.empRole === "Manager") && (
                              <Grid item xs={12}>
                                <Stack spacing={1} direction={"row"}>
                                  <Typography className="title">
                                    Service Agreement :{" "}
                                    <FilePdfTwoTone
                                      className="icon-size"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        props.handleScopeAgreementOpen(
                                          true,
                                          props.scopeDetails,
                                          scopeFinalTotal
                                        );
                                      }}
                                    />
                                  </Typography>
                                </Stack>
                              </Grid>
                            )} */}
                        <div className={"btnContainer"}>
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => {
                              setOpenScopeModal(true);
                            }}
                          >
                            Change Scope
                          </Button>
                        </div>

                        {(user.empRole === "Admin" ||
                          user.empRole === "Manager") && (
                          <ScopeDetailSection
                            scopeDetails={props.scopeDetails}
                            currentScope={currentScope}
                            chargePercentages={props.chargePercentages}
                            jrData={props.jrData}
                            setScopeFinalTotal={setScopeFinalTotal}
                          />
                        )}
                      </Grid>
                    </>
                  )}
                </>
              ) : (
                // )
                <div>
                  <h3 style={{ marginTop: "1rem" }}>
                    <em>
                      Your bid has been{" "}
                      <b style={{ color: "red" }}>rejected.</b>
                    </em>
                  </h3>
                </div>
              ))
            )}
          </Stack>
        </Grid>
      )}

      <Modal
        destroyOnClose={true}
        width="700px"
        title="Edit Scope"
        open={editScopeModal}
        onCancel={() => {
          setEditScopeModal(false);
        }}
        footer={false}
      >
        {editScopeModal && (
          <EditScopeForm
            fetchData={props.fetchData}
            openJR={props.jrData}
            setEditScopeModal={setEditScopeModal}
          />
        )}
      </Modal>
      <Modal
        destroyOnClose={true}
        width="700px"
        title="Scope of Work"
        open={openScopeModal}
        onCancel={() => {
          setOpenScopeModal(false);
        }}
        footer={false}
      >
        <Grid container spacing={1}>
          <ScopeDetails
            jrData={props.jrData}
            scopeDetails={props.scopeDetails}
            chargePercentages={chargePercentages}
            setScopeFinalTotal={setScopeFinalTotal}
            fetchData={props.fetchData}
          />

          <Grid item xs={12}>
            {props.jrData.job_status !== "Reviewing" &&
              props.jrData.job_status !== "Finalizing" && (
                <AnimateButton>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    sx={{ ml: 2, float: "right" }}
                    onClick={() => setEditScopeModal(true)}
                  >
                    Change Scope
                  </Button>

                  <Button
                    variant="outlined"
                    size="small"
                    color="secondary"
                    sx={{ ml: 2, float: "right" }}
                    onClick={() => setOpenScopeModal(false)}
                    footer={false}
                  >
                    Cancel
                  </Button>
                </AnimateButton>
              )}
          </Grid>
        </Grid>
      </Modal>
      <Modal
        destroyOnClose={true}
        width="700px"
        title="Accept Bid"
        open={showAcceptBidModal}
        onCancel={() => setShowAcceptBidModal(false)}
        footer={false}
      >
        {isSubmitting ? (
          <LoadScreen />
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <Stack spacing={1}>
                <Typography>
                  Are you sure you want to accept this bid on behalf of{" "}
                  <strong>{props.jrData.clientName}</strong>?
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="How did you get approval?"
                variant="outlined"
                value={confirmationText}
                onChange={handleConfirmationChange}
                error={confirmationError}
                helperText={confirmationError ? "This field is required" : ""}
                required
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Stack spacing={1}>
                <AnimateButton>
                  <Button
                    size="sm"
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      acceptBid();
                      // if (paymentMethod) {
                      //   console.log(paymentMethod, "BKHBFIWEFJVIHUJGVUHYi");
                      //   acceptBid();
                      // } else {
                      //   console.log(paymentMethod, "BKHBFIWEFJVIHUJGVUHYi");
                      //   setPaymentRequiredModal(true);
                      // }
                    }}
                    sx={{ ml: 2, float: "right" }}
                    disabled={!confirmationText}
                  >
                    Accept
                  </Button>
                  <Button
                    size="sm"
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={() => setShowAcceptBidModal(false)}
                    sx={{ ml: 2, float: "right" }}
                  >
                    Cancel
                  </Button>
                </AnimateButton>
              </Stack>
            </Grid>
          </Grid>
        )}
      </Modal>
      <Modal
        destroyOnClose={true}
        width="700px"
        title="Bid Details"
        open={showBidDetailsModal}
        onCancel={() => setShowBidDetailsModal(false)}
        footer={
          props.jrData.assigned_vendor_id === null ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                setCancelBidAlert(true);
              }}
            >
              Cancel Bid
            </Button>
          ) : (
            <Grid item xs={12} md={12}>
              <Stack spacing={1}>
                <AnimateButton>
                  <Button
                    size="sm"
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setShowAcceptBidModal(true);
                    }}
                    sx={{ ml: 2, float: "right" }}
                  >
                    Accept
                  </Button>
                  <Button
                    size="sm"
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={() => setShowBidDetailsModal(false)}
                    sx={{ ml: 2, float: "right" }}
                  >
                    Cancel
                  </Button>
                </AnimateButton>
              </Stack>
            </Grid>
          )
        }
      >
        <BidDetails
          chargePercentages={
            props.jrData.is_send_to_market === 1
              ? props.chargePercentages.marketPercentages
              : props.chargePercentages.crmPercentages
          }
          bidDetails={props.bidDetails[0]}
          setShowBidDetailsModal={setShowBidDetailsModal}
          showBidDetailsModal={showBidDetailsModal}
        />
      </Modal>

      <Modal
        destroyOnClose={true}
        width="700px"
        open={cancelBidAlert}
        onCancel={() => setCancelBidAlert(false)}
        footer={
          <>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={cancelBidConfirm}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{ marginLeft: 4 }}
              onClick={() => {
                setCancelBidAlert(false);
              }}
            >
              Cancel
            </Button>
          </>
        }
      >
        Are you sure to cancel bid?
      </Modal>

      <Modal
        title="Add Payment Details"
        open={addPaymentMethodModal}
        onCancel={() => setAddPaymentMethodModal(false)}
        footer={[
          <Button key="later" onClick={() => setAddPaymentMethodModal(false)}>
            Not now, Later!
          </Button>,
        ]}
        bodyStyle={{ overflowY: "auto", maxHeight: "calc(90vh - 200px)" }}
      >
        <NewPaymentMethod
          setAddPaymentMethodModal={setAddPaymentMethodModal}
          vendorAddingClient={true}
          clientUserId={props.jrData.client_id}
          clientName={props.jrData.clientName}
          onSuccess={onSuccess}
          successUrl={
            window.location.origin + "/dashboard/vendorMode/bidding/activeJobs"
          }
          mayBeLater={mayBeLater}
        />
      </Modal>
      {/* <Modal
        destroyOnClose={true}
        width="700px"
        title="Add Payment"
        open={paymentRequiredModal}
        onCancel={() => setPaymentRequiredModal(false)}
        footer={false}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>
            Please add atleast <b>ONE</b> payment method in order to accept the
            bid.
          </Typography>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
              gap: "1rem",
              marginTop: "2rem",
            }}
          >
            <Button
              size="sm"
              type="button"
              variant="contained"
              color="primary"
              onClick={() => setShowBidDetailsModal(false)}
            >
              Cancel
            </Button>

            <Button
              size="sm"
              type="button"
              variant="contained"
              color="primary"
              onClick={() => setAddPaymentMethodModal(true)}
            >
              Add Card
            </Button>
          </Stack>
        </Stack>
      </Modal> */}
    </>
  );
};

export default ExpandedTilePhase1;
